import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import '@caios/ui/theme.css';
import '@caios/ui/controls.css';
import { ThemeProvider, ToastProvider, readTheme } from '@caios/ui';
import './app.css';
import { router } from './router.tsx';

document.documentElement.dataset.theme = readTheme();   // before first paint: no flash of the wrong theme
const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
